
const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=wia-launcher> <template> <style include=shared-style></style> <style>" + require("./wia-launcher.css") + "</style> <div on-click=showVideoPopup> <slot></slot> <video id=mobileVideo controls=\"\" controlslist=nodownload preload=none src=[[videoPath]]></video> </div> </template> </dom-module>");

require('./wia-launcher.js');



// WEBPACK FOOTER //
// ./home/en-US/js/wia-launcher/wia-launcher.html